<template>
  <div class="ha-news">
    <news-component />
  </div>
</template>

<script>
import NewsComponent from "@/components/NewsComponent";
export default {
  name: "News",
  components: {
    NewsComponent
  },
}
</script>

<style scoped>

</style>